<!-- Footer -->
<!-- <div class="container footer-first p-0" style="max-width: 80%;"> -->
  <!-- <section class="d-flex justify-content-center justify-content-lg-between p-4 border-bottom "> -->
    <!-- Left -->
    <!-- <div class="me-5  d-lg-block w-30"> -->
      <!-- <h4 class="text-bold">{{'footer.waspage' | translate}}</h4> -->
    <!-- </div> -->
    <!-- Left -->

    <!-- Right -->
    <!-- <div class="w-30"> -->
      <!-- <h4 class="text-bold">
        
        {{'footer.comments' | translate}}
      </h4> -->
      <!-- <a href="" class="me-4 text-reset">
        <i class="fab fa-facebook-f"></i>
      </a>
      <a href="" class="me-4 text-reset">
        <i class="fab fa-twitter"></i>
      </a>
      <a href="" class="me-4 text-reset">
        <i class="fab fa-google"></i>
      </a>
      <a href="" class="me-4 text-reset">
        <i class="fab fa-instagram"></i>
      </a>
      <a href="" class="me-4 text-reset">
        <i class="fab fa-linkedin"></i>
      </a>
      <a href="" class="me-4 text-reset">
        <i class="fab fa-github"></i>
      </a> -->
    <!-- </div> -->
    <!-- Right -->
  <!-- </section> -->
 <!-- </div> -->
<footer class="text-center text-lg-start bg-body-tertiary text-muted">
  <!-- Section: Social media -->


  <!-- Section: Social media -->

  <!-- Section: Links  -->
  <section class="">
    <div class="container text-start text-md-start mt-5 footer-links">
      <!-- Grid row -->
      <div class="row mt-3 text-start">
        <!-- Grid column -->
        <div class="col-md-3 col-lg-3 col-xl-3 o mb-4  text-start">
          <!-- Content -->
          <!-- <h6 class="text-uppercase fw-bold mb-4 title-link">
            {{'footer.Importantlinks' | translate}}

          </h6> -->
<p style="margin-bottom:12px;"> 
<a href="mailto:library@uofcanada.edu.eg" class="me-4 text-reset px-2">
<i class="fa fa-envelope"><span style="font-family:'Lato';size:12px;font-weight:100;">&nbsp;&nbsp;library&#64;uofcanada.edu.eg</span></i></a></p>
<p style="margin-bottom:12px;" class="me-4 text-reset px-2"> 
<i class="far fa-clock" ><span style="font-family:'Lato';size:12px;font-weight:100;">&nbsp;&nbsp;Working Hours: 
Sunday to Thursday: 9:00 AM to 4:00 PM</span></i></p>
<p style="margin-bottom:12px;"><a href="tel:%2016838" class="me-4 text-reset px-2">
<i class="fas fa-phone"><span style="font-family:'Lato';size:12px;font-weight:100;">&nbsp;&nbsp;Hotline 16838</span></i></a></p>
<p style="margin-bottom:12px;"> 
<a href="https://g.page/UofCanada" class="me-4 text-reset px-2">
<i class="fas fa-map-pin"><span style="font-family:'Lato';size:12px;font-weight:100;">&nbsp;&nbsp;New Administrative Capital City, Plot No. (X1-05)</span></i></a></p>
<!-- <p>
            {{'footer.EducationAndtraining' | translate}}
 </p> -->
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="col-md-3 col-lg-3 col-xl-3 o mb-4  text-start">
          <!-- Links -->
          <h6 class="text-uppercase fw-bold mb-4 title-link">
           {{'footer.UofCanada' | translate}}
          </h6>
          <p style="margin-bottom:14px;">
            <a href="https://uofcanada.edu.eg/about" class="text-reset">
              {{'footer.about' | translate}}
            </a>
          </p>
          <p style="margin-bottom:14px;">
            <a href="https://uofcanada.edu.eg/campus-life" class="text-reset">
              {{'footer.Campus' | translate}}
            </a>
          </p>
          <p style="margin-bottom:14px;">
            <a href="https://uofcanada.edu.eg/contact-us" class="text-reset">
              {{'footer.Contact' | translate}}
            </a>
          </p>

          

        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="col-md-3 col-lg-3 col-xl-3 o mb-4  text-start">
          <!-- Links -->
          <h6 class="text-uppercase fw-bold mb-4 title-link">
            
            {{'footer.UPEI Cairo Campus' | translate}}
          </h6>
          <p style="margin-bottom:14px;">
            <a href="https://upei.uofcanada.edu.eg/about" class="text-reset">
              {{'footer.About' | translate}}
            </a>
          </p>
          <p style="margin-bottom:14px;">
            <a href="https://upei.uofcanada.edu.eg/admissions-requirements" class="text-reset">
              {{'footer.Admission' | translate}}
            </a>
          </p>
          <p style="margin-bottom:14px;">
            <a href="https://upei.uofcanada.edu.eg/tuition-fees-egyptian-students" class="text-reset">
              {{'footer.Tuition' | translate}}

            </a>
          </p>
         </div>
        <!-- Grid column -->

                <!-- Grid column -->
            <div class="col-md-3 col-lg-3 col-xl-3  mb-md-0 mb-4  text-start">
                  <!-- Links -->
                  <h6 class="text-uppercase fw-bold mb-4 title-link">
                    {{'footer.FollowUs' | translate}}
                  </h6>
                  <p>
                    <a href="https://www.facebook.com/Universities-of-Canada-in-Egypt-Library-111411353780198" class="me-4 text-reset px-2">
                    <i class="fab fa-facebook-f"></i>
                  </a>
                  <a href="https://twitter.com/UofCanada" class="me-4 text-reset px-2">
                    <i class="fab fa-x-twitter"></i>
                  </a>
                  <a href="https://www.instagram.com/uofcanadalibrary" class="me-4 text-reset px-2">
                    <i class="fab fa-instagram"></i>
                  </a>
                   <a href="https://www.linkedin.com/school/uofcanada" class="me-4 text-reset px-2">
                    <i class="fab fa-linkedin-in"></i>
                  </a>
                   <a href="https://www.youtube.com/c/uofcanada" class="me-4 text-reset px-2">
                    <i class="fab fa-youtube"></i>
                  </a>
                </p>
                  <!-- <p>
                    
                    {{'footer.Accessibilitytools' | translate}}

                  </p> -->
                  <!-- <p> <a href="" class="me-4 text-reset px-2">
                    <i class="fab fa-github"></i>
                  </a>
                  <a href="" class="me-4 text-reset px-2">
                    <i class="fab fa-linkedin"></i>
                  </a>
                </p> -->
                 
                </div> 
                <!-- Grid column -->


      </div>
      <!-- Grid row -->
    </div>
  </section>
  <!-- Section: Links  -->

  <!-- Copyright -->
  <div class="container" style="max-width: 80%;">
     <!-- Section: Social media -->
  <section class="d-flex justify-content-center justify-content-lg-between border-bottom">
    <!-- Left -->
    <div class="me-5 d-none d-lg-block">
      <!-- {{'footer.copyright1' | translate}} -->
       
      <a class="text-reset fw-bold" href="">
        {{'footer.copyrights' | translate}}

        </a>
    </div>
    <!-- Left -->

    <!-- Right -->
    <div>
      <img src="assets/images/New.png" width="200px" height="75px" [attr.alt]="'menu.header.image.logo' | translate"/></div>
    <!-- Right -->
  </section>
  <!-- Section: Social media -->
  </div>
  <!-- Copyright -->
</footer>
<!-- Footer -->